/**
 * Converts billingAccounts field into a text to be shown on UI
 * @param {String} company - company name
 * @param {String} accountNumber
 * @returns {string}
 */
export const billingAccountTextFormatter = (details) => {
  if (!details) {
    return null;
  }

  const { company, accountNumber } = details;
  return company ? `${company} - ${accountNumber}` : company;
};

/**
 * Normalize billingAccounts item to accountNumber (to send only number to the server)
 * @param value - billing account object
 * @returns {string}
 */
export const billingAccountToNumber = (value) => ((value && value.accountNumber) ? value.accountNumber : value);

/**
 * Check if value is a boolean and normalize it
 * @param value - value as a string
 * @returns {boolean or string}
 */
export const normalizeBoolean = (value) => {
  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return value;
};
